// MainLayout.jsx
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ChatBot from './ChatBot';

const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>{children}</main>
      <Footer />
      <ChatBot />
    </div>
  );
};

export default MainLayout;
